var _a;
import * as IFRAME_TEMPLATES from './iframeTemplates';
var DEFAULT_IFRAME_TITLES = (_a = {},
    _a[IFRAME_TEMPLATES.LAUNCHER] = 'Button für Stilfinder und Terminbuchung',
    _a[IFRAME_TEMPLATES.EXIT_INTENT] = 'Stilfinder Exit Intent Ad',
    _a[IFRAME_TEMPLATES.EXIT_INTENT_MOBILE] = 'Stilfinder Exit Intent Ad',
    _a[IFRAME_TEMPLATES.RESULT] = 'Persönliche Vorschläge',
    _a[IFRAME_TEMPLATES.ENTRY] = 'Stilfinder Formular',
    _a[IFRAME_TEMPLATES.INLINE] = 'Stilfinder Formular',
    _a[IFRAME_TEMPLATES.DYNAMIC] = null,
    _a[IFRAME_TEMPLATES.ARBITRARY] = null,
    _a[IFRAME_TEMPLATES.PRELOADER] = "Preloader",
    _a[IFRAME_TEMPLATES.PREVIEW] = "Stilfinder Preview",
    _a);
export default DEFAULT_IFRAME_TITLES;
